import React from "react";

import { RideSkeleton } from "@rimac-seguros/ride-system-components";

import { SliderRange } from "@/components/molecules/SliderRange";

export const SavingTime = ({ list, defaultValue, disabled, loading, onSelected, isGreatterValue }) => {
  return (
    <div className="relative border-b py-ride-gl-spacing-4xlarge border-ride-sys-color-border-default">
      <h2 className="ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge lg:ride-sys-text-title-2xlarge-default lg:mb-ride-gl-spacing-4xlarge">
        ¿Cuántos años quieres ahorrar?
      </h2>
      <div>
        {!loading ? (
          <SliderRange
            list={list}
            defaultValue={defaultValue}
            defaultTextToSelected="años"
            onSelect={onSelected}
            isGreatterValue={isGreatterValue}
            disabled={disabled}
          />
        ) : (
          <RideSkeleton type="rectangle" height={48} width="100%" />
        )}
      </div>
    </div>
  );
};
